import { Star, Phone } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { PHONE_TEL } from "@/site";

export const Reviews = () => (
    <section data-testid="reviews-section" className="bg-white py-20 sm:py-24 lg:py-28">
        <div className="mx-auto w-full max-w-7xl px-5 sm:px-8">
            <SectionHead
                eyebrow="Customer Trust"
                title="What Our Customers Say"
                text="We only publish genuine feedback from real customers — never made-up reviews."
                testId="reviews-heading"
            />
            <Reveal delay={0.15}>
                <div
                    data-testid="reviews-placeholder"
                    className="mt-14 rounded-3xl border-2 border-dashed border-slate-300 bg-slate-50 p-10 sm:p-14"
                >
                    <div className="flex gap-1.5" aria-hidden="true">
                        {[...Array(5)].map((_, i) => (
                            <Star key={i} className="h-6 w-6 text-slate-300" />
                        ))}
                    </div>
                    <h3 className="mt-6 font-display text-2xl font-semibold text-slate-900">
                        Customer reviews coming soon
                    </h3>
                    <p className="mt-3 max-w-xl text-base leading-relaxed text-slate-600">
                        As genuine reviews come in from homeowners, businesses, and drivers we've helped, they'll be
                        featured right here. If we've helped you before, mention it next time you call — we'd love to
                        hear how we did.
                    </p>
                    <a
                        data-testid="reviews-call-link"
                        href={PHONE_TEL}
                        className="mt-6 inline-flex items-center gap-2 text-sm font-extrabold uppercase tracking-wider text-gold-dark transition-colors hover:text-navy-950"
                    >
                        <Phone className="h-4 w-4" />
                        Call us and see for yourself
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
